export default "__VITE_ASSET__mpHlTNj$__"